jQuery(document).ready(function($){

  $('.site-nav--has-dropdown ul li.site-nav--active').parent().closest('li').addClass('site-nav--active').parent().closest('li').addClass('site-nav--active');
  $('.site-nav__dropdown-child li.site-nav--active').parent().addClass('site-nav--active');
 
  $('.mobile-menu ul li.site-nav--active').parent().closest('li').addClass('site-nav--active').parent().closest('li').addClass('site-nav--active');
  $('.mobile-menu li.site-nav--active').parent().addClass('site-nav--active');
 
  
  
  $('.filter-group h4').on('click', function(e){
    $('.main-sidebar .navbar-nav').css('height', $('.main-sidebar .navbar-nav').outerHeight() + 200);
    $(document.body).trigger("sticky_kit:recalc"); 
  });

  
  
  $('.header-bar__search')
  .on('mouseenter', function(){ $(this).addClass('on'); })
  .on('mouseleave', function(){ $(this).removeClass('on'); });
  
   if($(window).width() > 991){
      $('main.container').imagesLoaded(function(){
        if($('body').hasClass("template-page-campaign") || $('body').hasClass("template-index")){
        }
        else{
          var minHeight = $(window).height();
          if($('main.container').outerHeight() > minHeight){
            var minHeight = $('main.container').outerHeight() + 50;
          }
          $('.main-sidebar').css('min-height', minHeight);
          $('.main-sidebar').css('height', minHeight);

          $('.main-sidebar .navbar-nav').css('height', $('.main-sidebar .navbar-nav').outerHeight() + 200);
          $(".main-sidebar .navbar-nav").stick_in_parent({offset_top: 30});
        }
        
      });
     
     
     
    }
  
    $(function() {
      var wH = $(".header-bar").height(),
          thetop;
      $(window).scroll(function(){
          thetop = jQuery(window).scrollTop();
          if(thetop>wH) // height of float header
              $('header').addClass('stick');
          else
            $('header').removeClass('stick');
       });
  });
  
  $(window).scroll(function(){

	var scrolltop = $(window).scrollTop();
    if ($(this).scrollTop() > 1) {  
     // $('body').addClass("sticky");
      
      /*
      var product_offsettop = 38; //todo - set to height of header
      if (scrolltop > product_offsettop) {
        var w = $('#collection-alt-page #sidebar-left').width();
        $('#collection-alt-page #sidebar-left').css('width',w+'!important').addClass('stick');
      } else {
        $('#collection-alt-page #sidebar-left').removeAttr('style').removeClass('stick');
      }
      */
                  
    } else {
     // $('body').removeClass("sticky");
      //$('#collection-alt-page #sidebar-left').removeAttr('style').removeClass('stick');
    }

  });
  
  /*
  //fix dropdown slider jerk using customslide fn:
  http://stackoverflow.com/questions/7244382/slide-subsequent-elements-as-well-when-using-jquery-uis-slide-effect
  */
  
  $('.section-header').click(function(e) {
    e.preventDefault();
    var nav = $(this).closest('nav');
    
  		$('#stockists #rest-of-world').hide();
  		$('#stockists>ul').hide();
    
    $('.section-list').hide();
    $('.section-list', nav).toggle('slide', { direction: 'up' }, 500);
  });
  
  //product detail page
  $('.modal-body').enscroll({
    showOnHover: false,
    verticalTrackClass: 'track3',
    verticalHandleClass: 'handle3'
  });
  
  /*
  $('.wishlist-pro-wrapper-page .accordion-section-title').addClass('active');
  $('.wishlist-pro-wrapper-page .accordion-section-content').addClass('open');
  */
  
  if ($('#collection-alt-page').length){
    //$('#sidebar-left').stickit({top:0, screenMinWidth:992});
    
    $('#collection-alt-page .grid__item a').click(function(e) {
    	e.preventDefault();
        var parent = $(this).parent();
      	var index = $('.grid__item').index(parent);
      
        var slider = $('.product-single__hero #slider').data('flexslider');
        slider.flexAnimate(index); 
      
      	$('#collection-alt-page .grid__item a').removeClass('active');
		$(this).addClass('active');
    });
            
  }
 
   if ($('body').hasClass('template-product')){
   
    // $("#innerStick").stick_in_parent({offset_top: 50});
     
    // Product page set heights and stick in parent
     if($(window).width() > 991){
       $('.product-single').imagesLoaded(function(){
         var productDescHeight = $('#desc').outerHeight();
         var productImagesHeight = $('.product-single__hero').outerHeight();
         console.log(productImagesHeight);
         console.log(productDescHeight);

         if(productDescHeight < productImagesHeight){
           $('#desc').css('min-height', productImagesHeight);
           $('#desc').css('height', productImagesHeight);
         }
         else{
           $('.product-single__hero, .product-single').css('min-height', productDescHeight);
           $('.product-single__hero, .product-single').css('height', productDescHeight); 
         }

         $("#innerStick").stick_in_parent({offset_top: 50});
       });

     }
    
    $(window).bind("afterresize", function() {
      if ($('body').hasClass('template-product')){
        // Product page set heights and stick in parent
        if($(window).width() > 991){
          $('#desc').css('min-height', $('.product-single__hero').outerHeight() + 50);
          $('#desc').css('height', $('.product-single__hero').outerHeight() + 50);
          $(document.body).trigger("sticky_kit:recalc");
        }
        else{
          $('#desc').css('min-height', 'auto');
          $('#desc').css('height', 'auto');
        }

      }
	});
     
     if($('.photo').hasClass('video')){
       var myPlayer = jQuery('#productVideo').YTPlayer();
       var aspectRatio = parseFloat($('#productVideo').attr('data-video-height')) / parseFloat($('#productVideo').attr('data-video-width'));
       aspectRatio = aspectRatio *100 + '%';
       $('.product__video').css("paddingBottom", aspectRatio);

       myPlayer.on("YTPPause ", function (e) {
         jQuery( ".buttonBar").removeClass('paused');
       });

       myPlayer.on("YTPPlay ", function (e) {
         jQuery( ".buttonBar").addClass('paused');
       });

     }
     
     var owl = $('.photo-gallery');
     owl.owlCarousel({    
       loop:true,
       items:1,
       nav: true,
       margin:0,
       navText: ["",""],
       mouseDrag: false,
       stagePadding: 0,	
       autoplay:false  
     });
         
     if($('.photo').hasClass('video')){
       owl.on('changed.owl.carousel', function(event) {
         myPlayer.YTPPause();
       });
     }

     dotcount = 1;

     jQuery('.owl-dot').each(function() {
       jQuery( this ).addClass( 'dotnumber' + dotcount);
       jQuery( this ).attr('data-info', dotcount);
       dotcount=dotcount+1;
     });

     slidecount = 1;

     jQuery('.owl-item').not('.cloned').each(function() {
       jQuery( this ).addClass( 'slidenumber' + slidecount);
       slidecount=slidecount+1;
     });

     jQuery('.owl-dot').each(function() {	
       grab = jQuery(this).data('info');
       slidegrab = jQuery('.slidenumber'+ grab +' .photo-object').attr('data-thumbnail');
       if((jQuery('.slidenumber'+ grab +' .photo-object')).hasClass('product__video')){
         jQuery(this).addClass('videoSlide');
         jQuery(this).append('<div class="playBtn"></div>');
       }
       jQuery(this).css("background-image", "url("+slidegrab+")");  	

     });

     if($('.photo-gallery').hasClass("scrollable")){
       jQuery('.photo-gallery').prepend('<div id="upScroll" data-index="0" data-total="' + $('.owl-dots .owl-dot').length +'"><span></span></div><div id="downScroll" class="active"><span></span></div');
     }

     $('#upScroll').click(function(){
       var currentIndex =  parseFloat($('#upScroll').attr('data-index'));
       var newIndex =  currentIndex - 1;
       var maxIndex =  parseFloat($('#upScroll').attr('data-total')) - 4;
       if(newIndex >= 0 && newIndex <= maxIndex){
         $('#upScroll').attr('data-index', newIndex);
         var topSitting = newIndex * 195; // 160
         var marginTop = '-' + topSitting + 'px';

         $('.owl-dots .owl-dot:first').animate({'margin-top':marginTop},1000,function(){
         })
       }

       if(newIndex > 0){ $('#upScroll').addClass("active");}
       else{$('#upScroll').removeClass("active");}
       if(newIndex == maxIndex){$('#downScroll').removeClass("active");}
       else{$('#downScroll').addClass("active");}
     })

     $('#downScroll').click(function(){
       var newIndex =  parseFloat($('#upScroll').attr('data-index')) + 1;
       var maxIndex =  parseFloat($('#upScroll').attr('data-total')) - 4;
       if(newIndex >= 0 && newIndex <= maxIndex){
         $('#upScroll').attr('data-index', newIndex);
         var topSitting = newIndex * 195; // 160
         var marginTop = '-' + topSitting + 'px';

         $('.owl-dots .owl-dot:first').animate({'margin-top':marginTop},1000,function(){
         })
       }

       if(newIndex > 0){ $('#upScroll').addClass("active");}
       else{$('#upScroll').removeClass("active");}
       if(newIndex == maxIndex){$('#downScroll').removeClass("active");}
       else{$('#downScroll').addClass("active");}
     })

    
  }
  
  
  if ($('#stockists').length) {
    
    $('#stockists #sidebar-left a').click(function(e) {
    	e.preventDefault();
      
    	$('#stockists #sidebar-left .section-list').hide();
      
      	var nav = $(this).closest('nav').attr('id');
    	var id = $(this).data('id');
      	var title = $(this).text();
      	
      	if (id == 'rest-of-world' || id == 'online' || id == 'ONLINE') $('#stockists nav#state').hide();
        if (id == 'australia') {
          $('#stockists nav#state').show();
      	  $('#stockists nav#state .sidebar-title').html('NSW');
          id = 'NSW';
        }
      
      	$('#stockists nav#'+nav+' .sidebar-title').html(title);
      
  		$('#stockists>ul').hide();
  		$('#stockists #'+id).fadeIn('slow');
    });
    
    //init stockist page
    var id = 'NSW'; //needs to be nsw
  	$('#stockists #rest-of-world').hide();
    $('#stockists nav#region .sidebar-title').text('Australia');
    $('#stockists nav#state .sidebar-title').text('NSW');
    $('#stockists #'+id).fadeIn('slow');
    
  }
  
  //jump to required url
  $('select.jump-to-url').on('change', function(e){ 
    if (this.value.length > 0) window.location.href = this.value;
  });
  
  $('.selectpicker').selectpicker({
    style: 'btn-info'
  });

  
  $('input, textarea').placeholder();
  
});